// Module
var code = "<inv-tooltip data-cy=\"pricingPlanRenewalPeriods-tooltip\" ng-if=\"$ctrl.showTooltip\" context=\"::$ctrl.tooltipContext\" template=\"::$ctrl.tooltipTemplate\" glyph=\"::'info-circle'\">\n</inv-tooltip>";
// Exports
module.exports = code;